import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Feed from "./Pages/Graduado/Feed";
import PublicationRead from "./Pages/Graduado/PublicationRead";
import EventPage from "./Pages/Graduado/EventPage";
import DonatePage from "./Pages/Graduado/DonatePage";
import NewPublicationPage from "./Pages/Graduado/NewPublicationPage";
import EditPublicationPage from "./Pages/Graduado/EditPublicationPage";
import ProfilePage from "./Pages/Graduado/ProfilePage";
import MyPublicationsPage from "./Pages/Graduado/MyPublicationsPage";
import PadrinhoPage from "./Pages/Graduado/PadrinhoPage";
import JobPage from "./Pages/Graduado/JobPage";
import JobDetailsPage from "./Pages/Graduado/JobDetailsPage";
import MainGraduadoLayout from "./Layouts/MainGraduadoLayout";
import MainLayout from "./Layouts/MainLayout";
import LandingPage from "./Pages/LandingPage/landingPage";
import OQueEAlumni from "./Pages/Public/OQueEAlumni";
import ObjectivosDaComunidade from "./Pages/Public/ObjectivosDaComunidade";
import DiaDoAlumni from "./Pages/Public/DiaDoAlumni";
import FundoAlumni from "./Pages/Public/FundoAlumni";
import Embaixadores from "./Pages/LandingPage/Embaixadores";
import Nucleos from "./Pages/LandingPage/Nucleos";
import Inscricao from "./Pages/LandingPage/Inscricao";
import Contactos from "./Pages/LandingPage/Contactos";
import NoticiaDetalhada from "./Components/Noticia/NoticiaDetalhada";
import SiginPage from "./Pages/Auth/SiginPage";
import ParceiroPage from "./Pages/Parceiro/ParceiroPage";
import GraduateFormPage from "./Pages/Graduado/GraduateFormPage";
import EmpregabilidadePage from "./Pages/Graduado/EmpregabilidadePage";
import EmployerSurveyPage from "./Pages/Empregador/EmployerSurveyPage";
import RecuperarSenhaPage from "./Pages/Auth/RecuperarSenhaPage";
import PedidoColabaoracaoPage from "./Pages/Graduado/PedidoColabaoracaoPage";
import PublicEventDetail from "./Pages/Graduado/PublicEventDetail";
import NotFoundPage from "./Pages/Public/NotFoundPage";
import EmpregabilidadePublicoPage from "./Pages/Graduado/EmpregabilidadePublicoPage";



import { ProtectedRoute, USER_GROUPS } from "./utils/permissions";

const queryClient = new QueryClient();

const router = createBrowserRouter([
  // Rotas públicas (sem proteção)
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/feed/:id",
        element: <PublicationRead />,
      },
      {
        path: "/o-que-e-alumni",
        element: <OQueEAlumni />,
      },
      {
        path: "/objectivos",
        element: <ObjectivosDaComunidade />,
      },
      {
        path: "/dia-do-alumni",
        element: <DiaDoAlumni />,
      },
      {
        path: "/fundo-alumni",
        element: <FundoAlumni />,
      },
      {
        path: "/embaixadores",
        element: <Embaixadores />,
      },
      {
        path: "/nucleos",
        element: <Nucleos />,
      },
      {
        path: "/inscricao",
        element: <Inscricao />,
      },
      {
        path: "/contactos",
        element: <Contactos />,
      },
      {
        path: "/noticias/:id",
        element: <NoticiaDetalhada />,
      },
      {
        path: "/eventos/:uuid",
        element: <PublicEventDetail />,
      },
      {
        path: "/empregabilidade-publico",
        element: <EmpregabilidadePublicoPage />,
      }
    ],
  },
  
  // Rotas de autenticação
  {
    path: "/account/login",
    element: <SiginPage />,
  },
  {
    path: '/account/recuperar-senha',
    element: <RecuperarSenhaPage />,
  },
  {
  path: "*",
  element: <NotFoundPage />,
  },
  
  // Rotas protegidas (plataforma)
  {
    element: <MainGraduadoLayout />,
    children: [
      {
        path: "/feed",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <Feed />
          </ProtectedRoute>
        ),
      },
      {
        path: "/eventos",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <EventPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/doar",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <DonatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/publicar",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED]}>
            <NewPublicationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/publicacoes/:id/editar",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED]}>
            <EditPublicationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/minhas-publicacoes",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED]}>
            <MyPublicationsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfil",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/padrinho",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <PadrinhoPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/vagas",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <JobPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/vagas/:id",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <JobDetailsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/parceiros",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.EMPLOYER]}>
            <ParceiroPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/contactos",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <Contactos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/inquerito/:id",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED]}>
            <GraduateFormPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/empregabilidade",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <EmpregabilidadePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/employer-survey",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.EMPLOYER]}>
            <EmployerSurveyPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/pedido-colaboracao",
        element: (
          <ProtectedRoute allowedGroups={[USER_GROUPS.GRADUATED, USER_GROUPS.EMPLOYER]}>
            <PedidoColabaoracaoPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();